import apiHeader from "@/helpers/apiHeader";

const myTaskService = {
  list(type, page, params) {
    return apiHeader.get(`dashboard/my-task/${type}?page=` + page, { params });
  },
  detailTask(order) {
    return apiHeader.get("my-task/" + order);
  },
};

export default myTaskService;
